import React, {FC} from 'react';
import {Helmet} from 'react-helmet';
import {useTranslation} from 'react-i18next';
import { TLCOrganic } from '../../../components/Grossharvestofproducts/TLC'; 

const TLCOrganicPage: FC = () => {
    const {t} = useTranslation();

    return (
        <>
            <Helmet>
                <title>Транспортно-логистические центры (ТЛЦ)</title>
            </Helmet>
            <TLCOrganic />
        
        </>
    );
};

export default TLCOrganicPage
